import { Controller } from "@hotwired/stimulus"

// Starts the ZIP download once, the first time the status page renders a
// finished export. The server renders this controller only for an export the
// user just started and has not downloaded yet (ExportAutodownload), so a page
// opened later from the notification, the e-mail or a new tab never downloads. The user who clicked "Exportovať" gets the file without a
// second click, while a later re-render (the next Turbo refresh, a reload, the
// Back button) does not download it again.
export default class extends Controller {
  static values = { url: String, key: String }

  connect() {
    if (!this.urlValue || this.#alreadyStarted()) return

    this.#markStarted()
    window.location.assign(this.urlValue)
  }

  #alreadyStarted() {
    try {
      return window.sessionStorage.getItem(this.#storageKey) === "1"
    } catch {
      return false
    }
  }

  #markStarted() {
    try {
      window.sessionStorage.setItem(this.#storageKey, "1")
    } catch {
      // Storage blocked: the download still starts; the button remains for retries.
    }
  }

  get #storageKey() {
    return `file-export-downloaded:${this.keyValue}`
  }
}
